import React, { useState } from 'react'
import { ImageGallery, ImageProps } from './ImageGallery'
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled'
import { styled } from '@mui/material'
import { Tour3dModal } from './Tour3dModal'
import { ThreeDIcon } from './ThreeDIcon'
import Chip from '@mui/material/Chip'
// eslint-disable-next-line
const TourWrapper = styled('div')({
  fontFamily: 'Montserrat',
  fontSize: '1.1rem',
  fontWeight: '600',
  textAlign: 'center',
  lineHeight: '24 / 18',
  letterSpacing: '0px',
  color: 'white',
  pointerEvents: 'none',
})

const PlayButton = styled(PlayCircleFilledIcon)({
  width: 48,
  height: 48,
  pointerEvents: 'none',
})

const ThreeDTourChip = ({
  size = 'small',
}: {
  size?: 'small' | 'large'
}): JSX.Element => {
  const fontSize = size === 'small' ? '0.875rem' : '1.125rem'

  return (
    <Chip
      variant='filled'
      icon={<ThreeDIcon />}
      label='Start 3D Tour'
      sx={{ fontSize: fontSize, fontWeight: 600 }}
    />
  )
}

const SpaceImageGallery = (
  space
): JSX.Element | null => {
  const photos = space.spacePhotos ?? []
  const srcs: Array<string | null | undefined> = photos.map(
    (photo) => photo?.url
  )
  const filteredSrcs: string[] = srcs.filter(
    (src) => typeof src === 'string'
  )

  const has3dTour = !!space.tour_url
  const [show3dTour, setShow3dTour] = useState(false)

  const on3dTourClick = (): void => {
    if (space.tour_url) {
      setShow3dTour(true)
    }
  }

  const tourImage: ImageProps | null = has3dTour
    ? {
      src: filteredSrcs[0],
      filter: 'brightness(65%) saturate(80%) blur(3px)',
      notShownPill: <ThreeDTourChip />,
      onClick: on3dTourClick,
      overlay: (
        <TourWrapper className='tourOverlay'>
          <div>
            <PlayButton onClick={on3dTourClick} className='playButton' />
          </div>
          <ThreeDTourChip size='large' />
        </TourWrapper>
      ),
    }
    : null

  const images: ImageProps[] = [
    ...(tourImage ? [tourImage] : ([] as ImageProps[])),
    ...filteredSrcs.map((src) => ({ src: src })),
  ]

  if (show3dTour && space.tour_url) {
    return (
      <Tour3dModal onClose={() => setShow3dTour(false)} url={space.tour_url} />
    )
  }

  return <ImageGallery images={images} />
}

export default SpaceImageGallery
